/** Add 20%
 * @param {bigint}value
 * @return {bigint}
 */
export function calculateGasMargin(value: bigint): bigint {
  return (value * BigInt(120)) / BigInt(100)
}
